import type { RightKey } from '@k2/domain/rights'
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useOrganizationStore } from '../store'

export const useOrganizationId = () => {
  const route = useRoute()
  return computed(() => {
    const fromRoute = route.params.organizationId
    if (typeof fromRoute === 'string' && fromRoute.length > 0) return fromRoute
    return undefined
  })
}

// NFR-A5: every scheduled time is read and written in this zone.
export const useOrganizationTimeZone = () => {
  const organizationId = useOrganizationId()
  const organizationStore = useOrganizationStore()
  watch(
    organizationId,
    id => {
      if (id) void organizationStore.getOrLoadDetails(id)
    },
    { immediate: true }
  )
  return computed(() => (organizationId.value ? organizationStore.details[organizationId.value]?.timezone : undefined))
}

export const useOrganizationRight = (right: RightKey) => {
  const organizationId = useOrganizationId()
  const organizationStore = useOrganizationStore()
  return computed(() => !!organizationId.value && organizationStore.hasRight(organizationId.value, right))
}
